import { PAGE_LOCAL_STORAGE_ACTIONS } from "contexts/PageLocalStorageContext/PageLocalStorageContext.types"
import {
  useContextDispatch,
  useStateDispatch
} from "contexts/PageLocalStorageContext/PageLocalStorageContextProvider"
import { useCallback } from "react"
import {
  INITIAL_PAGE_SETTINGS,
  PageLocalStorageType
} from "utils/constants/localStorage.constants"

import useUserContext from "../useUserContext"

const usePageLocalStorageContext = () => {
  const pageLocalStorage = useStateDispatch()
  const dispatch = useContextDispatch()
  const { userUniqueId } = useUserContext()

  const setPageLocalStorage = useCallback(
    (newValues: PageLocalStorageType) => {
      localStorage.setItem(userUniqueId, JSON.stringify(newValues))
      dispatch({
        type: PAGE_LOCAL_STORAGE_ACTIONS.SET_PAGE_LOCAL_STORAGE,
        payload: newValues
      })
    },
    [dispatch, userUniqueId]
  )

  const clearPageLocalStorage = useCallback(() => {
    localStorage.removeItem(userUniqueId)
    dispatch({
      type: PAGE_LOCAL_STORAGE_ACTIONS.SET_PAGE_LOCAL_STORAGE,
      payload: INITIAL_PAGE_SETTINGS
    })
  }, [dispatch, userUniqueId])

  return {
    userPageSettingsLocalStorage: pageLocalStorage,
    setUserPageSettingsLocalStorage: setPageLocalStorage,
    clearPageLocalStorage
  }
}

export default usePageLocalStorageContext
